import { forwardRef } from 'react';
import { SelectableCard, SelectableCardGroup } from '@gusto/workbench-formik';
import { CardHeader, Grid, Heading } from '@gusto/workbench';

export const WHAT_TO_USE_FIND_YOUR_PLAN_KEY = 'WHAT_TO_USE_FIND_YOUR_PLAN';

export enum WhatToUseFindYourPlanValues {
  PAYROLL = 'payroll',
  TIME_AND_ATTENDANCE = 'time',
  HIRING_AND_ONBOARDING = 'hiring',
  EMPLOYEE_BENEFITS = 'benefits',
  TALENT_MANAGEMENT = 'talent',
  INSIGHTS_AND_REPORTING = 'reporting',
}

const WhatToUseFindYourPlan = forwardRef<HTMLFieldSetElement>((_, ref) => {
  return (
    <SelectableCardGroup
      ref={ref}
      className="question"
      name="whatToUseFindYourPlan"
      id="whatToUseFindYourPlan"
      label="What do you want to use Gusto for?"
      helperText="Select all that apply."
    >
      <Grid rowGap={3} columnGap={2} maxWidth={632} maxWidthMd="100%">
        <SelectableCard
          type="checkbox"
          aria-label="Payroll"
          value={WhatToUseFindYourPlanValues.PAYROLL}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Payroll
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Employee benefits"
          value={WhatToUseFindYourPlanValues.EMPLOYEE_BENEFITS}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Benefits
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Time + attendance"
          value={WhatToUseFindYourPlanValues.TIME_AND_ATTENDANCE}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Time tracking + project tracking
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Hiring + onboarding"
          value={WhatToUseFindYourPlanValues.HIRING_AND_ONBOARDING}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Hiring + onboarding
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Talent management"
          value={WhatToUseFindYourPlanValues.TALENT_MANAGEMENT}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Talent management
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Insights + reporting"
          value={WhatToUseFindYourPlanValues.INSIGHTS_AND_REPORTING}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Insights + reporting
            </Heading>
          </CardHeader>
        </SelectableCard>
      </Grid>
    </SelectableCardGroup>
  );
});

export default WhatToUseFindYourPlan;
